import React from 'react';

export function SelectedOptionToText(props: {
    selectedValue?: string | null | undefined;
    options: {
        text: string;
        value: string;
    }[];
}) {
    if (!props.selectedValue) {
        return null;
    }
    const option = props.options.find((i) => i.value === props.selectedValue);
    if (!option) {
        return <>{props.selectedValue}</>;
    }
    return <>{option.text}</>;
}
